import { RotateCcw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { FileHistoryItem } from "@/types/file-history";

interface HistoryTableProps {
  histories: FileHistoryItem[];
  onSelect: (history: FileHistoryItem) => void;
  onRestore: (history: FileHistoryItem) => void;
  isRestoring: boolean;
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("ko-KR");
}

export function HistoryTable({
  histories,
  onSelect,
  onRestore,
  isRestoring,
}: HistoryTableProps) {
  if (histories.length === 0) {
    return (
      <div className="rounded-lg border p-12 text-center text-sm text-muted-foreground">
        버전 기록이 없습니다.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="whitespace-nowrap">생성 일시</TableHead>
          <TableHead>제목</TableHead>
          <TableHead>저장 유형</TableHead>
          <TableHead className="text-right">글자 수</TableHead>
          <TableHead className="w-24" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {histories.map((history) => (
          <TableRow
            key={history._id}
            className="cursor-pointer"
            onClick={() => onSelect(history)}
          >
            <TableCell className="whitespace-nowrap text-sm">
              {formatDateTime(history.createdAt)}
            </TableCell>
            <TableCell className="max-w-xs truncate">
              {history.title || "제목 없음"}
            </TableCell>
            <TableCell>
              <Badge
                variant={history.saveType === "custom" ? "default" : "secondary"}
              >
                {history.saveType === "custom" ? "수동" : "자동"}
              </Badge>
            </TableCell>
            <TableCell className="text-right text-sm text-muted-foreground">
              {history.contentLength?.toLocaleString() ?? "-"}
            </TableCell>
            <TableCell className="text-right">
              <Button
                variant="outline"
                size="sm"
                disabled={isRestoring}
                onClick={(event) => {
                  event.stopPropagation();
                  onRestore(history);
                }}
              >
                <RotateCcw className="mr-1 h-3.5 w-3.5" />
                복원
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
